import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../components/home/HeroSection';
import Solutions from '../components/home/Solutions';
import Showcase from '../components/home/Showcase';
import Journey from '../components/home/Journey';
import Trust from '../components/home/Trust';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div data-testid="home-page">
      <HeroSection />
      <Solutions />
      <Showcase />
      <Journey />
      <Trust />
    </div>
  );
};

export default Home;
